import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['price', 'pet']

  updatePrice(event) {
    const selected = event.target.selectedOptions[0]
    this.priceTarget.value = selected.dataset.price || ''
  }

  updatePets(event) {
    const selected = event.target.value

    if (!selected) return

    fetch(`/appointments/pets?user_id=${selected}`)
      .then((response) => response.json())
      .then((data) => {
        const petSelect = this.petTarget.tomselect
        petSelect.clear()
        petSelect.clearOptions()
        petSelect.refreshOptions(false)

        data.pets.forEach((pet) => {
          petSelect.addOption({ value: pet.id, text: pet.name })
        })

        petSelect.refreshOptions(false)
        petSelect.setValue('')
      })
  }
}
